import { DateSeparator, DateSeparatorProps } from 'stream-chat-react';

export const CustomDateSeparator = (props: DateSeparatorProps) => (
  <DateSeparator {...props} calendar={false} format={'DD-MM-YYYY'} />
);
